import * as React from 'react';

import {EmptyAddCard} from 'shells/card/empty-add-card';
import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {TickCircleIcon} from 'shells/icon/svg/tick-circle-icon';
import {TwoLine} from 'shells/two-line/two-line';
import {TwoLineButtonCard} from 'shells/two-line/two-line-button-card';

import type {GetDripSequence_campaign_goal as GoalFragment} from 'nutshell-graphql-types';

import {getColor} from '../drip-sequence-page/color-icon-variants';
import type {Variant} from '../drip-sequence-page/color-icon-variants';

import styles from './goal-card.module.css';

type Props = {
    isLoading: boolean;
    goal: GoalFragment | null | undefined;
    onClick?: (goalId: string) => void;
    variant?: Variant;
};

export function GoalCard(props: Props) {
    const {goal, onClick} = props;
    const color = getColor(props.variant, colors.plum);

    if (goal && !props.isLoading) {
        return (
            <TwoLineButtonCard
                // @ts-expect-error
                borderColor={color}
                onClick={onClick ? () => onClick(goal.id) : undefined}
            >
                <TwoLine
                    icon={TickCircleIcon}
                    iconSize={20}
                    iconColor={color}
                    topRow={
                        <span>
                            <b>Goal:</b>&nbsp;{goal.humanReadableTitle}
                        </span>
                    }
                    bottomRow={goal.humanReadableSubtitle}
                    isLargeWithSmallBottomRow={true}
                />
            </TwoLineButtonCard>
        );
    }

    return (
        <div className={styles['add-goal-container']}>
            <EmptyAddCard
                text='Add a goal'
                onClick={onClick ? () => onClick('NEW') : () => {}}
                background='white'
                size='small'
                withoutIcon={true}
                color={color}
                isLoading={props.isLoading}
            />
        </div>
    );
}
